'use client';

import React from 'react';
import { useCart } from '@/context/CartContext';
import { ShoppingCart } from 'lucide-react';
import { usePathname } from 'next/navigation';

export function FloatingCartButton() {
  const { itemCount, openDrawer } = useCart();
  const pathname = usePathname();

  // Hide on checkout page
  if (pathname === '/checkout' || pathname?.startsWith('/checkout/')) {
    return null;
  }

  if (itemCount === 0) return null;

  return (
    <button
      type="button"
      onClick={openDrawer}
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2.5 px-4 py-3 bg-[#0066FF] hover:bg-[#0052CC] text-white rounded-full shadow-xl shadow-[#0066FF]/30 transition-all hover:scale-105 cursor-pointer font-sans"
      title="View Shopping Cart"
    >
      <div className="relative">
        <ShoppingCart className="size-5" />
        <span className="absolute -top-2 -right-2 size-5 rounded-full bg-amber-400 text-slate-950 font-black text-[10px] flex items-center justify-center shadow-xs">
          {itemCount}
        </span>
      </div>
      <span className="text-xs font-bold hidden sm:inline">Cart</span>
    </button>
  );
}
